import { Component, Input, OnInit } from '@angular/core';
import { common_message, NewMessage, PatientProfileQuery } from './../../../../models/message';
import {
    PromiseResult,
    ApiResult
} from 'src/app/models/PromiseResult';
import { DoctorsService } from 'src/app/services/doctors.service';
import { SelectItem } from 'primeng/api/selectitem';
import { MessagecenterService } from 'src/app/services/messagecenter.service';
import { LazyLoadEvent } from 'primeng';
import { PatientAccount } from 'src/app/models/PatientAccount';
import { HttpErrorResponse } from '@angular/common/http';
import { TraceClassDecorator } from '@sentry/angular';
import { ENV_URLS } from '../../../../../environments/environment';
import { roles } from '../../../../constant/constant';
@Component({
    selector: 'app-patientv-message-centre',
    templateUrl: './patientv-message-centre.component.html',
    styleUrls: [
        './patientv-message-centre.component.css',
        '../../../../../assets/css/custom-egd.css'
    ]
})
@TraceClassDecorator()
export class PatientvMessageCentreComponent implements OnInit {
    @Input('patient_guid')
    patient_guid: string = '';

    @Input('consultation_id')
    consultation_id: number = 0;

    @Input('patientData')
    patientData: PatientAccount = null;

    patient_name: string = '';
    MRNToSend: number = 0;
    CRNToSend: string = '';
    PVLToSend: string =
        ENV_URLS.PORTAL_BASE_URL +
        '/doctor/patientview/' +
        this.patient_guid +
        '/' +
        this.consultation_id;

    cols: [];
    temp: any[];
    data: any[] = [];
    sentdata: common_message[] = [];
    message: NewMessage;
    newMessageToSend: NewMessage = {
        to_user_guid: [],
        patient_guid: '',
        subject: '',
        message: '',
        reply_id: null
    };
    doctor_list: SelectItem[] = [];
    selectUserType: string = 'patient_user';
    readonly max_subject_length: number;
    readonly max_message_length: number;
    selecteddoctos = [];
    api_result: ApiResult = new ApiResult(false);
    api_msg_result: ApiResult = new ApiResult(false);
    selectedMRNToSend: string = null;
    selectedCRNToSend: string = null;
    selectedPVLToSend: string = null;
    showLinkedRisksOnly = false;
    mrnKey: boolean = false;
    crnKey: boolean = false;
    pvlKey: boolean = false;
    selectedMode = 0;
    showMsg: any;
    compose = {
        read: false,
        write: false,
        both: true
    };

    loading: boolean;
    totalRecords: number;
    first: number = 0;
    query: PatientProfileQuery = new PatientProfileQuery();
    //
    newMessageToSendSubjet: string = '';
    newMessageToSendMsg: string = '';
    callApi: boolean = false;
    form_reset: boolean = false;

    //

    constructor(
        private readonly doctorsService: DoctorsService,
        private readonly messageService: MessagecenterService
    ) {
        this.max_subject_length = 100;
        this.max_message_length = 500;
    }

    async init(): Promise<void> {

        this.patient_name = ((this.patientData?.first_name || '') + ' ' + (this.patientData?.last_name || ''));
        this.MRNToSend = this.patientData?.medical_record_number || 0;
        this.CRNToSend = this.patientData?.consultation[0]?.consultation_request_number || '';

        await this.composeMessages();
        this.api_result = new ApiResult(false);
    }

    resetForm(): void {
        this.form_reset = true;
        setTimeout(() => {
            this.form_reset = false;
        }, 1000);
    }

    ngOnInit(): void { }
    async sentMessages(): Promise<void> {
        this.selectedMode = 1;
        this.compose.write = false;
        this.api_result = new ApiResult(false);
        await this.getMessageList(null);
    }

    async receivedMessages(): Promise<void> {
        this.selectedMode = 2;
        this.compose.write = false;
        this.api_result = new ApiResult(false);
        await this.getMessageList(null);
    }

    async getMessageList(event: LazyLoadEvent): Promise<void> {
        this.loading = true;
        this.compose.both = false;
        this.data = [];
        this.sentdata = [];

        let page_no = 1;
        let records_per_page = 5;
        let sentEnable = false;

        switch (this.selectedMode) {
            case 0:
                this.loading = false;
                this.totalRecords = 0;
                this.first = 0;
                break;
            case 1:
                if (event != null) {
                    page_no = event.first / event.rows + 1;
                    records_per_page = event.rows;
                }
                sentEnable = true;
                this.callApi = true;
                break;
            case 2:
                if (event != null) {
                    page_no = event.first / event.rows + 1;
                    records_per_page = event.rows;
                }
                sentEnable = false;
                this.callApi = true;
                break;
        }

        if (this.callApi) {
            this.query.page_no = page_no;
            this.query.records_per_page = records_per_page;
            this.query.patient_guid = this.patient_guid;
            this.query.sent = sentEnable;
            await this.messageService
                .fetchPatientMessages(this.query)
                .toPromise()
                .then(resp => {
                    this.api_result.PromiseResult = resp;
                    if (resp.success) {
                        this.totalRecords = resp.data.count;
                        this.temp = resp.data.rows;
                        if (sentEnable) {
                            for (var i = 0; i < this.temp.length; i++) {
                                const message: common_message = {};
                                message.id = this.temp[i].id;
                                message.subject = this.temp[i].subject;
                                message.message = this.temp[i].message;
                                message.date = this.temp[i].created_at;
                                for (
                                    var j = 0;
                                    j < this.temp[i].message_recipient.length;
                                    j++
                                ) {
                                    message.to =
                                        this.temp[i].message_recipient[j]
                                            .egd_users.first_name +
                                        ' ' +
                                       ( this.temp[i].message_recipient[j]
                                            .egd_users.middle_name==null?'':this.temp[i].message_recipient[j]
                                            .egd_users.middle_name) +
                                        ' ' +
                                        this.temp[i].message_recipient[j]
                                            .egd_users.last_name;
                                    this.sentdata.push(message);
                                }
                            }
                            this.data = this.sentdata;
                        } else {
                            for (var i = 0; i < this.temp.length; i++) {
                                const message: common_message = {};
                                message.id = this.temp[i].id;
                                message.subject = this.temp[i].subject;
                                message.message = this.temp[i].message;
                                message.date = this.temp[i].created_at;
                                message.from =
                                    this.temp[i].egd_users.first_name +
                                    ' ' +
                                    (this.temp[i].egd_users.middle_name==null?'':this.temp[i].egd_users.middle_name) +
                                    ' ' +
                                    this.temp[i].egd_users.last_name;
                                this.sentdata.push(message);
                            }
                            this.data = this.sentdata;
                        }
                    }
                })
                .catch((error: HttpErrorResponse) => {
                    this.api_result.ServerError = error.error;
                    this.api_result.PromiseResult.success = false;
                    // this.api_result.Posting = false;
                });
        }
        this.loading = false;
    }

    async composeMessages(): Promise<void> {
        this.compose.write = true;
        this.compose.read = false;
        this.totalRecords = 0;
        this.first = 0;
        this.selectedMode = 0;
        if (!this.doctor_list.length)
            await this.GetDoctors();
    }

    async GetDoctors(): Promise<void> {
        this.api_result = new ApiResult(true);
        this.doctor_list = [];
        await this.doctorsService
            .findUserList({})
            .toPromise()
            .then(result => {
                this.api_result.PromiseResult = result;
                if (result.success) {
                    const temp: SelectItem[] = [];
                    for (let i = 0; i < result.data.length; i++) {
                        temp.push({
                            label:
                                result.data[i].first_name +
                                ' ' +
                               ( result.data[i].middle_name==null?'':result.data[i].middle_name) +
                                ' ' +
                                result.data[i].last_name +
                                ' (' +
                                result.data[i].d_specialty_type.specialty_name +
                                ', ' +
                                result.data[i].country.country_name +
                                ')',
                            value: result.data[i].user_guid
                        });


                    }
                    this.doctor_list = temp;
                } else {
                    this.api_result.ErrorModel = result.error;
                }
            })
            .catch((error: HttpErrorResponse) => {
                this.api_result.ServerError = error.error;
                this.api_result.PromiseResult.success = false;
                this.api_result.Posting = false;
            });
        this.api_result.Posting = false;
    }

    showDetailMsg(data): void {
        this.compose.read = true;
        this.compose.write = false;
        this.showMsg = data;
    }
    closeShowDetailMsg(): void {
        this.compose.read = false;
        this.compose.write = false;
        this.showMsg = null;
        this.newMessageToSendSubjet = '';
        this.newMessageToSendMsg = '';
        this.selecteddoctos = null;
        this.api_result.ErrorModel = new ApiResult(true).ErrorModel;
    }

    async createMsg(): Promise<void> {
        this.api_msg_result = new ApiResult(true);
        this.api_msg_result.ErrorModel = new ApiResult(true).ErrorModel;
        this.newMessageToSend = {
            to_user_guid: [],
            patient_guid: '',
            subject: '',
            message: '',
            reply_id: null
        };
        if (this.selectUserType == 'patient_user') {
            this.newMessageToSend.to_user_guid = null;
            this.newMessageToSend.patient_guid = this.patient_guid;
        } else if (this.selectUserType == 'doctor_user') {
            this.newMessageToSend.patient_guid = null;
            for (var i = 0; i < this.selecteddoctos.length; i++) {
                this.newMessageToSend.to_user_guid.push(
                    this.selecteddoctos[i].value
                );
            }
        }
        this.newMessageToSend.subject = this.newMessageToSendSubjet;
        this.newMessageToSend.message = this.newMessageToSendMsg;

        await this.messageService
            .CreateMessage(this.newMessageToSend, roles.doctor)
            .toPromise()
            .then(async (result: PromiseResult) => {
                this.api_msg_result.PromiseResult = result;
                if (this.api_msg_result.PromiseResult.success) {
                    this.api_msg_result.ErrorModel.message =
                        'Message Sent Successfully';
                    this.newMessageToSendMsg = '';
                    this.newMessageToSendSubjet = '';
                    this.selecteddoctos = null;
                    this.mrnKey = false;
                    this.crnKey = false;
                    this.pvlKey = false;
                    this.resetForm();

                } else {
                    this.api_msg_result.ErrorModel =
                        this.api_msg_result.PromiseResult.error;
                }
                this.api_msg_result.Posting = false;
            })
            .catch((error) => {
                this.api_msg_result.Posting = false;
                this.api_msg_result.PromiseResult.success = false;
                this.api_msg_result.ServerError = error.error;
            });
    }

    sendMsg(): void {
        this.createMsg();
        this.receivedMessages();
    }

    updateMsg(): void {
        this.newMessageToSendMsg = '';
        if (this.mrnKey)
            this.newMessageToSendMsg += ('MRN : ' + this.MRNToSend + '\n');
        if (this.crnKey)
            this.newMessageToSendMsg += ('CRN : ' + this.CRNToSend + '\n');
        if (this.pvlKey)
            this.newMessageToSendMsg += ('PVL : ' + this.PVLToSend + '\n');
    }
    restMsg(): void {
        this.newMessageToSendMsg = '';
        this.newMessageToSendSubjet = '';
        this.api_result = new ApiResult(false);
        this.api_result.ErrorModel = new ApiResult(true).ErrorModel;
        this.api_result.ServerError = new ApiResult(true).ServerError;
        this.selecteddoctos = null;
        this.selectedMRNToSend = null;
        this.selectedCRNToSend = null;
        this.selectedPVLToSend = null;
    }
}
